var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCamera = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8502 4.61058H27.1517L26.0324 1.47363C25.955 1.25897 25.8133 1.07343 25.6266 0.942341C25.4398 0.811251 25.2172 0.74101 24.989 0.741211H14.3897C13.9233 0.741211 13.5053 1.03487 13.3498 1.47363L12.227 4.61058H7.52848C6.00147 4.61058 4.76465 5.8474 4.76465 7.37442V23.1283C4.76465 24.6553 6.00147 25.8921 7.52848 25.8921H31.8502C33.3773 25.8921 34.6141 24.6553 34.6141 23.1283V7.37442C34.6141 5.8474 33.3773 4.61058 31.8502 4.61058ZM19.6894 20.3644C16.6353 20.3644 14.1617 17.8908 14.1617 14.8368C14.1617 11.7827 16.6353 9.3091 19.6894 9.3091C22.7434 9.3091 25.217 11.7827 25.217 14.8368C25.217 17.8908 22.7434 20.3644 19.6894 20.3644ZM16.3728 14.8368C16.3728 15.7164 16.7222 16.56 17.3442 17.182C17.9662 17.804 18.8097 18.1534 19.6894 18.1534C20.569 18.1534 21.4126 17.804 22.0346 17.182C22.6565 16.56 23.006 15.7164 23.006 14.8368C23.006 13.9572 22.6565 13.1136 22.0346 12.4916C21.4126 11.8696 20.569 11.5202 19.6894 11.5202C18.8097 11.5202 17.9662 11.8696 17.3442 12.4916C16.7222 13.1136 16.3728 13.9572 16.3728 14.8368Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.764648,
    y: 0.741211,
    width: 37.8494,
    height: 33.1509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera.d0958087c5816c1318683cc7d46139f5.svg";